const LotteryPopup = ({ offer, onClose }) => {
  if (!offer) return null;

  const handleClaim = () => {
    window.open(offer.link, "_blank");
    onClose();
  };

  return (
    <>
      <style>{`
        @keyframes lotteryIn {
          from { transform: scale(0.85) translateY(30px); opacity: 0; }
          to   { transform: scale(1)    translateY(0);    opacity: 1; }
        }
        @keyframes prizePulse {
          0%,100% { box-shadow: 0 0 20px rgba(245,158,11,0.4), 0 4px 24px rgba(220,38,38,0.4); }
          50%     { box-shadow: 0 0 36px rgba(245,158,11,0.7), 0 4px 36px rgba(220,38,38,0.6); }
        }
        @keyframes backdropInL {
          from { opacity: 0; } to { opacity: 1; }
        }
        @keyframes shimmer {
          0%   { transform: translateX(-100%) skewX(-15deg); }
          100% { transform: translateX(300%)  skewX(-15deg); }
        }
        @keyframes badgeGlow {
          0%,100% { text-shadow: 0 0 8px rgba(245,158,11,0.6); }
          50%     { text-shadow: 0 0 20px rgba(245,158,11,1), 0 0 40px rgba(245,158,11,0.4); }
        }
      `}</style>

      {/* Backdrop */}
      <div
        className="fixed inset-0 z-[70] flex items-center justify-center px-5"
        style={{
          background: "rgba(0,8,18,0.72)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          animation: "backdropInL 0.3s ease forwards",
        }}
        onClick={onClose}
      >
        {/* Card */}
        <div
          className="relative w-full overflow-hidden"
          style={{
            maxWidth: "340px",
            borderRadius: "24px",
            background: "linear-gradient(180deg, #010f1e 0%, #012a4a 60%, #013a63 100%)",
            border: "1px solid rgba(70,143,175,0.22)",
            boxShadow: "0 24px 80px rgba(0,0,0,0.8), 0 0 0 1px rgba(245,158,11,0.08)",
            animation: "lotteryIn 0.4s cubic-bezier(0.32,0.72,0,1) forwards",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Top amber glow strip */}
          <div
            className="absolute top-0 left-0 right-0 h-px"
            style={{ background: "linear-gradient(90deg, transparent, rgba(245,158,11,0.7), transparent)" }}
          />

          {/* Header badge */}
          <div className="flex flex-col items-center pt-6 pb-4 px-5">
            <div
              className="pressStart text-center leading-relaxed"
              style={{
                fontSize: "9px",
                color: "#f59e0b",
                letterSpacing: "0.06em",
                animation: "badgeGlow 2.2s ease-in-out infinite",
              }}
            >
              ✦ YOU'VE BEEN SELECTED ✦
            </div>
            <div
              className="mt-1 medium text-center"
              style={{ fontSize: "11px", color: "rgba(255,255,255,0.35)", letterSpacing: "0.08em" }}
            >
              EXCLUSIVE FREE OFFER
            </div>
          </div>

          {/* Hero image */}
          <div className="relative w-full overflow-hidden" style={{ height: "180px" }}>
            <img
              src={offer.picture}
              alt={offer.name_short}
              className="w-full h-full object-cover"
              style={{ objectPosition: "center top" }}
            />
            {/* Gradient fade */}
            <div
              className="absolute inset-0"
              style={{
                background: "linear-gradient(to bottom, rgba(1,15,30,0) 30%, rgba(1,15,30,0.5) 65%, #010f1e 100%)",
              }}
            />
            {/* Shimmer sweep */}
            <div
              className="absolute inset-0 pointer-events-none overflow-hidden"
              style={{ borderRadius: "0" }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "40%",
                  height: "100%",
                  background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent)",
                  animation: "shimmer 2.8s ease-in-out infinite",
                  animationDelay: "0.8s",
                }}
              />
            </div>
            {/* FREE badge */}
            <div
              className="absolute top-3 left-3 pressStart text-white"
              style={{
                fontSize: "7px",
                letterSpacing: "0.08em",
                padding: "5px 9px",
                borderRadius: "6px",
                background: "linear-gradient(135deg, #16a34a, #15803d)",
                border: "1px solid rgba(255,255,255,0.2)",
                boxShadow: "0 2px 12px rgba(22,163,74,0.5)",
              }}
            >
              FREE
            </div>
          </div>

          {/* Content */}
          <div className="px-5 pt-4 pb-6">
            {/* Title */}
            <h2
              className="semiBold text-white leading-tight"
              style={{ fontSize: "22px", letterSpacing: "0.01em" }}
            >
              {offer.name_short}
            </h2>

            {/* Divider */}
            <div
              className="mt-2 mb-3"
              style={{
                height: "1px",
                background: "linear-gradient(90deg, rgba(245,158,11,0.4), rgba(220,38,38,0.2), transparent)",
              }}
            />

            {/* Adcopy */}
            <p
              className="medium leading-relaxed"
              style={{ color: "rgba(255,255,255,0.52)", fontSize: "13px" }}
            >
              {offer.adcopy}
            </p>

            {/* CTA */}
            <button
              onClick={handleClaim}
              className="w-full mt-5 semiBold text-white relative overflow-hidden"
              style={{
                padding: "16px",
                borderRadius: "14px",
                fontSize: "15px",
                letterSpacing: "0.07em",
                background: "linear-gradient(135deg, #f59e0b 0%, #dc2626 100%)",
                border: "1px solid rgba(245,158,11,0.3)",
                animation: "prizePulse 2.5s ease-in-out infinite",
              }}
            >
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  background: "linear-gradient(110deg, transparent 35%, rgba(255,255,255,0.14) 50%, transparent 65%)",
                }}
              />
              <span className="relative z-10">CLAIM YOUR PRIZE →</span>
            </button>

            {/* Dismiss */}
            <button
              onClick={onClose}
              className="w-full mt-3 medium"
              style={{
                padding: "10px",
                fontSize: "12px",
                color: "rgba(255,255,255,0.25)",
                letterSpacing: "0.03em",
              }}
            >
              Not interested
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LotteryPopup;
